import { defineStyle } from '@chakra-ui/react';

const RoomConfigStyled = defineStyle({
  middleValue: {
    textAlign: 'center',
  },
});

export default RoomConfigStyled;
